module.exports = __webpack_public_path__ + "img/game-earn.20c146fe.png";